import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'ps-divider',
  imports: [],
  template: `
    @if (isHorizontal()) {
      <hr class="hr" />
    } @else {
      <div class="vr"></div>
    }
  `,
  styleUrl: './divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerComponent {
  public readonly orientation = input<'horizontal' | 'vertical'>('horizontal');

  public readonly isHorizontal = computed(
    () => this.orientation() === 'horizontal',
  );
}
